import httpClient from '@/http-client'

export const get = (options = {}) => {
    return httpClient
        .get('/api/evaluation-examinations', options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
    return httpClient
        .post('/api/evaluation-examinations', data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}

export const update = data => {
    return httpClient
        .post('/api/evaluation-examinations/change-is-passed', data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}
export const displayUpdate = data => {
    return httpClient
        .post('/api/evaluation-examinations/display-update', data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}

export const formModel = (options = {}) => {
    return httpClient
        .get('/api/evaluation-examinations/form-view-models', options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}

export default { get, store, formModel, update, displayUpdate }

